import { getMousePosition } from "./helpers";
import { getNodeByAttr } from "./locate";
export function getPopupPosition(node, id, layoutNode, ev) {
    const eventNode = getNodeByAttr(`${id}`, node) || getNodeByAttr(`${id}`, layoutNode);
    if (eventNode) {
        const diff = ev ? getMousePosition(ev, eventNode) : { top: 0, left: 0 };
        const rect = eventNode.getBoundingClientRect();
        let placement = "horizontal";
        let left, height;
        let top = rect.top;
        if (rect.width > rect.height * 5) {
            placement = "vertical";
        }
        if (placement === "vertical") {
            left = rect.left + diff.left;
            height = rect.height;
        }
        else {
            left = rect.right;
            height = 0;
            top += diff.top;
        }
        return {
            top,
            left,
            height,
            width: rect.width,
            placementMode: placement,
        };
    }
}
export function correctPopupPosition(pos, trueSizes) {
    let { left, top } = pos;
    const eventHeight = pos.height;
    const { width, height } = trueSizes;
    const nodeLeft = left - width - pos.width;
    const nodeBottom = top + height + pos.height;
    const bodyCoords = document.body.getBoundingClientRect();
    if (width + left > bodyCoords.right) {
        if (pos.placementMode === "vertical") {
            left = bodyCoords.right - width;
        }
        else {
            left = nodeLeft > 0 ? nodeLeft : bodyCoords.right - width;
        }
    }
    if (nodeBottom > bodyCoords.top + bodyCoords.height) {
        top = top - trueSizes.height - eventHeight;
    }
    return { ...pos, left, top };
}
//# sourceMappingURL=popupPosition.js.map